export default {
  title: 'Partnere',
  search_placeholder: 'Søg efter partner...',
  buttons: {
    default_price_list: 'Standardprisliste',
    create_partner: 'Opret partner',
  },
  columns: {
    name: 'Navn',
    restaurants: 'Restauranter',
    shop_domain: 'Shopdomæne',
    status: 'Status',
    earning_enabled: 'Indtjening aktiveret',
  },
  statuses: {
    invited: 'Inviteret',
    active: 'Aktiv',
    suspended: 'Suspenderet',
  },
  actions: {
    edit: 'Rediger',
    view_billing: 'Se fakturering',
    view_as_partner: 'Vis som partner',
    suspend: 'Suspendér',
    unsuspend: 'Ophæv suspension',
  },
  suspension: {
    suspend_title: 'Suspendere denne partner?',
    suspend_description:
      'Alle partnerens teammedlemmer deaktiveres, og deres sessioner tilbagekaldes. Deres restauranter forbliver live.',
    unsuspend_title: 'Ophæve suspensionen af denne partner?',
    unsuspend_description: 'Alle partnerens teammedlemmer genaktiveres og kan logge ind igen.',
  },
  toasts: {
    load_error: 'Partnerne kunne ikke indlæses.',
    suspended: 'Partneren er blevet suspenderet.',
    unsuspended: 'Partnerens suspension er ophævet.',
    suspension_error: 'Partnerens status kunne ikke ændres.',
    view_as_error: 'Partnerens dashboard kunne ikke åbnes.',
  },
};
